import React from 'react';
import { LinearProgress } from '@mui/material';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import '../../scss/reusables/prograss.scss'

function Progress(props) {
    const { value } = props;
    return (
        <div className='progressbar-section'>
            <Box display="flex" alignItems="center">
                <Box width="100%" mr={1}>
                    <LinearProgress variant="determinate" value={value} />
                </Box>
                <Box minWidth={30}>
                    <Typography variant="body2" color="textPrimary">{value}%</Typography>
                </Box>
            </Box>
        </div>
    );
}

export default Progress;